import Headroom from "headroom.js";
import Choices from "choices.js";

export default {
    header: {
        search() {
            document.querySelector('form[data-id="quick-search"]').addEventListener('submit', function (e) {
                let val = this.querySelector('input[name="query"]').value;
                if (val === undefined || val === null || val.trim() === '') {
                    e.preventDefault();
                }
            })
        },
        // mobToggleSearch() {
        //     const search = document.querySelector('.search');
        //     document.querySelector('#toggle-search').addEventListener('click', function(e){
        //         search.classList.toggle('show');
        //     })
        // },
        initHeadroom() {
            /**
             * Get the body & header element
             */
            const body = document.querySelector('body');
            const header = document.querySelector("header");

            /**
             * Get the additional offset that we want for the page
             */
            const additionalOffset = body.classList.contains('disable-headroom-offset') ? 0 : 10;

            /**
             * Verify that we have found the header, and we want to update the next element with the size of the header
             */
            if (header) {
                let next = document.querySelector('[data-rel="' + header.getAttribute('data-target-headroom') + '"]');
                next.style.marginTop = `${parseFloat(header.offsetHeight) + additionalOffset}px`;
            }

            /**
             * Set the headromm with the element
             */
            const headroom = new Headroom(header, {
                "offset": 0,
                "tolerance": {
                    up: 10,
                    down: 5
                },
            });

            /**
             * Initialize the headroom
             */
            headroom.init();
        }
    },
    switchSlider() {
        const seeListBtns = Array.from(document.querySelectorAll('.full-list'));
        seeListBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                btn.parentElement.parentElement.classList.toggle('show-all');
            })
        })
    },
    toggleBtn() {
        const toggleBtns = Array.from(document.querySelectorAll('.toggle-btn'));

        toggleBtns.forEach(btn => {
            btn.addEventListener('click', function (e) {
                let targetEl = document.querySelector(btn.dataset.target);

                btn.classList.toggle('active');

                if (btn.classList.contains('active')) {
                    targetEl.classList.add('active');
                    targetEl.style.height = (targetEl.scrollHeight) + 'px';
                } else {
                    targetEl.classList.remove('active');
                    targetEl.style.height = 0;
                }

            })
        })
    },
    readMore() {

        const toggleBtns = Array.from(document.querySelectorAll('[data-read-more]'));

        toggleBtns.forEach((btn) => {


            const targetID = btn.dataset.moreTarget;
            const targetEl = document.querySelector(targetID);
            const targetElMaxHeight = Number(window.getComputedStyle(targetEl).maxHeight.split('px')[0]);

            if (targetElMaxHeight >= targetEl.scrollHeight) {
                btn.style.display = 'none';
            } else {
                btn.style.display = 'block';

                btn.addEventListener('click', (e) => {

                    if (btn.tagName == 'A') {
                        e.preventDefault();
                    }

                    if (targetEl) {
                        btn.classList.toggle('active');
                        targetEl.classList.toggle('active');
                        targetEl.classList.contains('active') ? targetEl.style.maxHeight = `${targetEl.scrollHeight}px` : targetEl.style.maxHeight = null;
                    }

                    if (btn.classList.contains('active')) {
                        btn.textContent = 'Read less';
                    } else {
                        btn.textContent = 'Read more';

                        if (window.innerWidth < 768) {
                            targetEl.scrollIntoView();
                        }
                    }
                })

            }

        })
    },
    toggleMenu(btnSelector, targetElSelector) {
        Array.from(document.querySelectorAll(btnSelector)).forEach(btnSelector => {
            btnSelector.addEventListener('click', function (e) {
                let target = btnSelector.nextElementSibling;

                Array.from(document.querySelectorAll(targetElSelector)).forEach(dropdown => {
                    if (dropdown !== target) {
                        dropdown.classList.remove('active');
                        dropdown.style.height = '0px';
                    }
                });

                target.classList.toggle('active');
                if (target.classList.contains('active')) {
                    target.style.height = (target.scrollHeight + 15) + 'px';
                } else {
                    target.style.height = '0px';
                }

                const menu = document.querySelector('.navbar-nav');
                menu.style.height = window.innerHeight - 70 + 'px';
            });
        });
    },
    featuredSchoolsSideBar() {
        const appContex = this;
        const container = document.querySelector('[data-featured-schools]');
        const tabs = Array.from(document.querySelectorAll('.featured .tabs button'));

        /**
         * Verify that we have the container for the featured schools
         */
        if (!container || !container.hasAttribute('data-source-url') || !container.getAttribute('data-source-url')) {
            return false;
        }

        /**
         * Create the tabs for the schools programs
         */
        tabs.forEach(tab => {
            /**
             * Create the container for the items
             */
            let category = document.createElement('div');

            /**
             * Set the attributes for the containers
             */
            category.dataset.category = tab.dataset.category;
            category.classList = 'program-format';

            /**
             * Deactivate the containers that are not the first one
             */
            if (!(tab.dataset.category === 'MG')) {
                category.classList.add('hidden');
            }

            /**
             * Append the category to the main container
             */
            container.append(category);
        });

        /**
         * Fetch the information from the source
         */
        fetch(container.getAttribute('data-source-url'))
        .then(response => response.json())
        .then(result => {
            /**
             * Iterate the schools and append them to the containers
             */
            Object.keys(result).forEach((id) =>  {
                let school = result[id];

                /**
                 * Verify that we have the schools programs in the information
                 */
                if (typeof school.programs == 'undefined' || !school.programs.length) {
                    return false;
                }

                /**
                 * Iterate the programs to add the schools to the containers
                 */
                school.programs.forEach((program) => {
                    // /**
                    //  * Collect the locations for the program
                    //  */
                    // let locations = program.campuses.reduce((acc, curr) => {
                    //     if (!acc.countries.includes(curr.country)) {
                    //         acc.countries.push(curr.country);
                    //     }

                    //     if (!acc.continents.includes(curr.continent)) {
                    //         acc.continents.push(curr.continent);
                    //     }

                    //     return acc
                    // }, { continents: [], countries: [] });

                    /**
                     * Create the item for the school
                     */
                    let item = document.createElement('a');

                    /**
                     * Set the content for the item
                     */
                    item.textContent = school.name;
                    item.setAttribute('href', `/program/${school.slug}/${program.id}`);

                    /**
                     * Append additional data attributes
                     */
                    item.dataset.slug = school.slug;
                    item.dataset.format = program.type_program;
                    item.dataset.category = program.type_title;
                    item.dataset.countries = (school?.countries && school.countries.length) ? school.countries.join(', '): '';
                    item.dataset.continents = (school?.continents && school.continents.length) ? school.continents.join(', ') : '';

                    /**
                     * Get the type of the program
                     */
                    let list = container.querySelector('div[data-category*="' + program.type_title + '"]');

                    /**
                     * Verify that we the container for the program and the schools is not in the list
                     */
                    if (!list || list.querySelector('[data-slug="' + school.slug + '"]')) {
                        return false;
                    }

                    /**
                     * Append the item to the container
                     */
                    list.appendChild(item);
                });
            });

            /**
             * Attach the features for the widget
             */
            appContex.sortFeaturedSchools();
            appContex.filterFeaturedSchoolsByProgramCategory();
            appContex.filterFeaturedSchoolsByCountryAndContinent();
        })
    },
    sortFeaturedSchools() {
        /**
         * Get the containers with the items
         */
        const containers = Array.from(document.querySelectorAll('.featured .schools-container .program-format'));

        /**
         * Iterate the containers and sort the items
         */
        containers.forEach(container => {
            /**
             * Get the items for the schools
             */
            let schools = Array.from(container.querySelectorAll('a'));

            /**
             * Sort the items by their name
             */
            schools.sort((a, b) => {
                return a.textContent.trim().localeCompare(b.textContent.trim());
            });

            /**
             * Replace the container content with the sorted list
             */
            container.textContent = '';
            schools.forEach(school => container.append(school));
        });
    },
    filterFeaturedSchoolsByProgramCategory() {
        const buttons = Array.from(document.querySelectorAll('.tabs .format-buttons button'));
        const containers = Array.from(document.querySelectorAll('.featured .schools-container .program-format'));

        buttons.forEach(button => {
            button.addEventListener('click', (e) => {
                buttons.forEach(tabBtn => e.target == tabBtn ? e.target.classList.add('active') : tabBtn.classList.remove('active'));
                containers.forEach(container => container.dataset.category === e.target.dataset.category ? container.classList.remove('hidden') : container.classList.add('hidden'));
            });
        })
    },
    filterFeaturedSchoolsByCountryAndContinent() {
        /**
         * Get the containers for the items
         */
        const containers = Array.from(document.querySelectorAll('.featured .schools-container .program-format'));
        const source = document.querySelectorAll('#featured-schools-regions li[data-value]');

        /**
         * Filter the items in the list
         */
        source.forEach((element) => {
            element.addEventListener('click', (event) => {
                /**
                 * Get the value for the filter
                 */
                let value = element.getAttribute('data-value');

                /**
                 * Verify that we have the value
                 */
                if (!value || typeof value == 'undefined') {
                    return false;
                }

                /**
                 * Mark the element as active
                 */
                element.classList.add('active');

                /**
                * Reset the rest of the items
                */
                source.forEach((item) => {
                    if (item != element) {
                        item.classList.remove('active');
                    }
                });
                

                /**
                 * Iterate the containers to filter their lists
                 */
                containers.forEach(list => {
                    let schools = Array.from(list.querySelectorAll('a'));

                    /**
                     * Iterate the items in the list and toggle their visibility
                     */
                    schools.forEach(school => {
                        /**
                         * By default we will hide the item
                         */
                        school.classList.add('hidden');

                        /**
                         * Based on the selected value toggle the items that match the value
                         */
                        switch (value) {
                            case "all":
                                school.classList.remove('hidden');
                            break;

                            case "United States of America":
                            case "United Kingdom":
                            case "Canada":
                                school.dataset.countries.includes(value) ? school.classList.remove('hidden') : true;
                            break;

                            case "Europe":
                            case "Australia":
                                school.dataset.continents.includes(value) ? school.classList.remove('hidden') : true;
                            break;

                            case "rest-of-the-world":
                                if (school.dataset.continents.includes('Asia') || school.dataset.continents.includes('Africa') || school.dataset.continents.includes('Middle East') || school.dataset.continents.includes('South America') || school.dataset.continents.includes('Latin America')) {
                                    school.classList.remove('hidden');
                                }
                            break;
                        }
                    });
                });
            });
        });
    },
    accordion() {
        // Toggle answers
        Array.from(document.querySelectorAll('.at-accordion')).forEach(accordion => {
            const acordionItemsArr = Array.from(accordion.querySelectorAll('.at-accordion-item'));

            acordionItemsArr.forEach(item => {
                item.querySelector('.at-accordion-header').addEventListener('click', function (e) {
                    let accActiveItem = this.parentElement;
                    let accBody = accActiveItem.querySelector('.at-accordion-body');

                    acordionItemsArr.forEach(accItem => {
                        if (accItem !== item) {
                            accItem.classList.remove('active');
                            accItem.querySelector('.at-accordion-body').style.height = '0px';
                        }
                    });

                    accActiveItem.classList.toggle('active');

                    if (accActiveItem.classList.contains('active')) {
                        accBody.style.height = `${accBody.scrollHeight}px`;
                    } else {
                        accBody.style.height = '0px';
                    }
                });
            });
        });
    },
    socialShare() {
        /**
         * Find the elements that have the component
         */
        document.querySelectorAll('[data-component="share-social"]').forEach((component) => {
            let parameters = { media: component.getAttribute('data-media'), url: component.getAttribute('data-url') };

            /**
             * Verify that we have the information for the media and url
             */
            if (!parameters.media || !parameters.url) {
                return false;
            }

            /**
             * Set default variables for the share window
             */
            let w = 800, h = 400, popup = true;

            /**
             * Attach a custom event to handle the sharing
             */
            component.addEventListener('click', () => {
                /**
                 * Set some setting based on the media
                 */
                switch (parameters.media) {
                    case 'twitter':
                        h = 300;
                    break;

                    case 'fancy':
                        w = 480;
                        h = 720;
                    break;

                    case 'google':
                        w = 500;
                    break;

                    case 'reddit':
                        popup = false;
                    break;

                    case 'skype':
                        w = 500;
                        h = 720;
                    break;
                }

                /**
                 * Open the window for sharing
                 */
                window.open(parameters.url, popup, 'width=' + w + ', height=' + h);
            });
        });
    }
}
